import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useCookieConsent } from '@/context/CookieConsentContext';
import { trackPageView } from '@/lib/ga';

export default function AnalyticsHandler() {
  const location = useLocation();
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    if (hasConsent) {
      try {
        // Create a clean path by combining pathname and search
        // Avoid concatenating empty search strings
        const path = location.search 
          ? `${location.pathname}${location.search}`
          : location.pathname;
          
        trackPageView(path);
      } catch (error) {
        // Silently accept the error - we don't want to break the app
      }
    }
  }, [hasConsent, location.pathname, location.search, location.key]);

  return null;
}